module.exports = __webpack_public_path__ + "static/media/leak-test.3b14318e.jpg";